import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { computeMilliWh } from '../../services/computation/computeMilliWh';
import { roundToDecimals } from '../../services/computation/roundToDecimals';
import CompareScoreChip from './CompareScoreChip';

function MetricCard({ name, icon, value, unit, score, scoreReference, total }) {
    const percentage = Math.round((score * 100) / total);
    return (
        <Card
            sx={{
                display: 'flex',
                minWidth: 150,
                position: 'relative',
                flexGrow: 1,
            }}
            variant="outlined"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: `${percentage}%`,
                        width: '100%',
                        backgroundColor: '#FFFFCC',
                        zIndex: 0,
                    }}
                ></Box>
                <Typography
                    variant="h6"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        px: 1,
                        color: '#666600',
                    }}
                >
                    {percentage}%
                </Typography>
            </Box>
            <CardContent
                sx={{
                    width: '100%',
                    py: 1,
                    px: 2,
                    zIndex: 1,
                }}
            >
                <Grid
                    container
                    direction="row"
                    spacing={1}
                    sx={{ height: '35px', position: 'relative' }}
                    alignItems="center"
                >
                    <Grid item>{icon}</Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'flex',
                            }}
                        >
                            <Typography variant="overline">{name}</Typography>
                        </Box>
                    </Grid>
                    <Box
                        sx={{
                            position: 'absolute',
                            right: '-18px',
                            top: 0,
                        }}
                    >
                        <CompareScoreChip
                            isCorner
                            score={score}
                            scoreReference={scoreReference}
                        />
                    </Box>
                </Grid>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'baseline',
                        flexDirection: {
                            xs: 'row',
                            sm: 'column',
                        },
                        gap: { xs: 1, sm: 0 },
                    }}
                >
                    <Typography variant="h5">{computeMilliWh(score)} mWh</Typography>
                    {value && (
                        <Typography
                            sx={{
                                marginLeft: {
                                    xs: 1,
                                    sm: 0,
                                },
                            }}
                        >
                            ({roundToDecimals(value, 2)} {unit})
                        </Typography>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
}

MetricCard.propTypes = {
    name: PropTypes.string,
    icon: PropTypes.element,
    value: PropTypes.number,
    unit: PropTypes.string,
    score: PropTypes.number,
    scoreReference: PropTypes.number,
    total: PropTypes.number,
};

export default MetricCard;
